import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SlipState } from '@bpos/v1/my-bets';
import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { HooksWireup, OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsDetailsResponse } from './my-bets-details.resolver';

@HooksWireup()
@Component({
    selector: 'ms-my-bets-details',
    templateUrl: './my-bets-details.component.html',
})
export default class MyBetsDetailsComponent extends OnRouteResolve<MyBetsDetailsResponse> {
    @HostBinding('class') className = 'mybets-redesign mybets-details cards';

    betslip?: MyBetsBetSlip;
    myBetsListContext: MyBetsListContext;

    constructor(
        route: ActivatedRoute,
        public sitecoreMyBets: SitecoreMyBetsConfig,
    ) {
        super(route);
    }

    onRouteResolved(model: MyBetsDetailsResponse): void {
        if (!model.hasErrors) {
            this.betslip = model.betslip;
            this.myBetsListContext = {
                isEventView: false,
                isPrintView: false,
                listType: this.betslip.state === SlipState.Open ? BetslipListType.Open : BetslipListType.Settled,
                migrationTabType: null,
                associatedAccount: model.associatedAccount || null,
                showMigrationTabs: false,
                showPrintButton: false,
                showFilter: false,
            };
        }
    }
}
